import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Search2"
});
const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.13201 1.54688C11.7706 1.54688 14.7191 4.55685 14.7191 8.2684C14.7191 9.56337 14.3593 10.8039 13.694 11.871L13.6353 11.9616L16.1278 14.5289C16.5122 14.9214 16.5539 15.5304 16.2528 15.9698L16.1923 16.0501L16.1278 16.1218C15.7178 16.5403 15.0654 16.5623 14.6295 16.1875L14.5589 16.1213L12.125 13.6131L12.0674 13.659C11.0506 14.4334 9.83675 14.8938 8.55192 14.9765L8.33715 14.9867L8.13201 14.9899C4.4934 14.9899 1.54492 11.98 1.54492 8.2684C1.54492 4.55685 4.4934 1.54688 8.13201 1.54688ZM8.13188 3.40588C5.52384 3.40588 3.40381 5.58002 3.40381 8.2684C3.40381 10.9568 5.52384 13.1309 8.13188 13.1309C9.07866 13.1309 9.98709 12.8452 10.7609 12.3108L10.9138 12.2006L11.0557 12.0898L11.6095 11.6485L12.0289 11.0227C12.5005 10.3189 12.7806 9.5071 12.8454 8.65528L12.8565 8.45803L12.86 8.2684C12.86 5.58002 10.7399 3.40588 8.13188 3.40588Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var search_2 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { search_2 as default };
